module.exports = __webpack_public_path__ + "img/drive_score.6ca535f9.svg";